import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import useMagnetic from "../../hooks/useMagnetic";

const LOGO_URL = "/logo-cropped.png";

const Header = ({ scrolled }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const headerBtnRef = useMagnetic({ strength: 0.25, radius: 100 });
  const scrollBehavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  useEffect(() => {
    const close = (event) => { if (event.type === 'popstate' || event.key === 'Escape') setMobileMenuOpen(false); };
    window.addEventListener('keydown', close);
    window.addEventListener('popstate', close);
    return () => { window.removeEventListener('keydown', close); window.removeEventListener('popstate', close); };
  }, []);

  const navLinks = [
    { label: "How it works", href: "#how-it-works" },
    { label: "Benefits", href: "#benefits" },
    { label: "FAQ", href: "#faq" }
  ];

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: scrollBehavior() });
    }
    setMobileMenuOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: scrollBehavior() });
  };

  return (
    <header className={`site-header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <nav className="nav-wrapper">
          <a href="/" className="logo">
            <div className="logo-wrapper">
              <img src={LOGO_URL} alt="Thryvin' AI Coaching" className="logo-image" />
            </div>
          </a>

          <div className="nav-links desktop-nav">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="nav-link"
                onClick={(e) => handleNavClick(e, link.href)}
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="header-cta desktop-nav">
            <button ref={headerBtnRef} className="header-waitlist-btn magnetic" onClick={scrollToTop}>
              Download
            </button>
          </div>

          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
            aria-expanded={mobileMenuOpen}
            aria-controls="mobile-navigation"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        {mobileMenuOpen && (
          <div className="mobile-menu" id="mobile-navigation">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="mobile-nav-link"
                onClick={(e) => handleNavClick(e, link.href)}
              >
                {link.label}
              </a>
            ))}
            <div className="mobile-cta">
              <button className="header-waitlist-btn" onClick={() => { scrollToTop(); setMobileMenuOpen(false); }}>
                Download
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
